function getGoogleSignInErrorMessage(error) {
  switch (error && error.code) {
    case "auth/popup-closed-by-user":
      return "Google sign-in was cancelled. You can try again whenever you're ready."
    case "auth/popup-blocked":
      return "Your browser blocked the Google sign-in window. Allow pop-ups and try again."
    case "auth/unauthorized-domain":
      return "This website isn't authorised for Google sign-in yet. Add its domain in Firebase Authentication settings."
    case "auth/operation-not-allowed":
      return "Google sign-in isn't enabled for this Firebase project yet."
    case "auth/network-request-failed":
      return "We couldn't connect to Google. Check your connection and try again."
    case "auth/account-exists-with-different-credential":
      return "An account already exists with this email. Sign in using its existing sign-in method."
    default:
      return "We couldn't sign you in with Google. Please try again."
  }
}

module.exports = { getGoogleSignInErrorMessage }
